module.exports = __webpack_public_path__ + "static/10-4192644217b02b5153b0550ffb296399.jpg";